// @ts-nocheck
import React, { useEffect } from 'react';
import { SelectAccount } from './SelectAccount';
import { SelectGL } from './SelectGL';
import { SelectCurrencies } from './SelectCurrencies';
import { SelectInventory } from './SelectInventory';
import { SelectSubInventory } from './SelectSubInventory';
import { SelectPriceList } from './SelectPriceList';
import { SelectProfileScale } from './SelectProfileScale';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// المكون الرئيسي الذي يعيد حقول الإدخال بناءً على نوع الحقل
export const DynamicInput = ({ param, value, onChange, organizationId }) => {
  const { name, name2, type } = param;
  const { i18n } = useTranslation();
  const label = i18n.language === 'en' ? name : name2;

  useEffect(() => {
    if (param.id === '9d1238fd-b530-4423-9533-0d258f8221dc') {
      console.log(value);
    }
  }, [onChange]);

  // console.log(param);

  switch (type) {
    case 'Inventory':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectInventory value={value} onChange={onChange} />
        </div>
      );
    case 'SubInventory':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectSubInventory value={value} onChange={onChange} organizationId={organizationId} />
        </div>
      );
    case 'Account':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectAccount value={value} onChange={onChange} />
        </div>
      );
    case 'GL':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectGL value={value} onChange={onChange} />
        </div>
      );
    case 'Currency':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectCurrencies value={value} onChange={onChange} />
        </div>
      );

    case 'Profile_Scale':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectProfileScale value={value} onChange={onChange} />
        </div>
      );

    case 'Price_List':
      return (
        <div className='form-group mb-3'>
          <label className='form-label'>{label}</label>
          <SelectPriceList value={value} onChange={onChange} />
        </div>
      );

    case 'bool':
      return (
        <div className='form-group mb-3'>
          <label className='form-label d-block mb-2'>{label}</label>
          <div className='d-flex flex-wrap gap-2'>
            <button
              type='button'
              className={`btn btn-sm ${
                value === true ? 'btn-success' : 'btn-outline-success'
              } position-relative d-flex align-items-center gap-1`}
              onClick={() => onChange(true)}
            >
              <i className={`fa-lg fas ${value === true ? 'fa-check-circle' : 'fa-circle'} fa-fw`}></i>
              {i18n.language === 'ar' ? 'مفعل' : 'Active'}
              {value === true && (
                <span className='position-absolute top-0 start-100 translate-middle p-1 bg-success border border-light rounded-circle'>
                  <span className='visually-hidden'>✓</span>
                </span>
              )}
            </button>

            <button
              type='button'
              className={`btn btn-sm ${
                value === true || value === 'null' ? 'btn-outline-danger' : 'btn-danger'
              } position-relative d-flex align-items-center gap-1`}
              onClick={() => onChange(false)}
            >
              <i className={`fa-lg fas ${value === true ? 'fa-times-circle' : 'fa-ban'} fa-fw`}></i>
              {i18n.language === 'ar' ? 'غير مفعل' : 'Inactive'}
              {!value && (
                <span className='position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle'>
                  <span className='visually-hidden'>✕</span>
                </span>
              )}
            </button>
          </div>
        </div>
      );

    default:
      return (
        <div className='form-group mb-3'>
          <label className='form-label mb-3'>{label}</label>
          <Form.Control
            className='form-control'
            type='text'
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            placeholder={i18n.language === 'ar' ? `أدخل ${name2}` : `Enter ${name}`}
          />
        </div>
      );
  }
};

// export const DynamicInput = ({ param, onChange }) => {
//   const { name, name2, type, value } = param;

//   switch (type) {
//     case 'Inventory':
//       return <SelectInventory label={name} label2={name2} value={value} onChange={onChange} />;
//     case 'Account':
//       return <SelectAccount label={name} label2={name2} value={value} onChange={onChange} />;
//     case 'bool':
//       return (
//         <div className='form-check mt-2'>
//           <Form.Check
//             type='switch' // تقدر تخليها 'checkbox' إذا تحب
//             id={`bool-${name}`}
//             label={name2 || name2}
//             checked={value === true}
//             onChange={e => onChange(e.target.checked)}
//           />
//         </div>
//       );
//     default:
//       return null;
//   }
// };
